import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';
import { REST_BASE_URL } from '../app.config';

interface UserSettingsDTO {
  printerDevice?: string;
  scannerDevice?: string;
  fingerabdruckDevice?: string;
  lichtbildDevice?: string;
  avSchluessel?: string;
  appTypeUrl?: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserSettingsService {
  private readonly userSettingsUrl = `${ REST_BASE_URL }/usersettings`;

  private userSettings = new BehaviorSubject<UserSettingsDTO | null>(null);
  readonly userSettings$ = this.userSettings.asObservable();
  readonly avSchluessel$ = this.userSettings$.pipe(
    map((userSettings) => userSettings?.avSchluessel)
  );
  readonly fingerabdruckDevice$ = this.userSettings$.pipe(
    map((userSettings) => userSettings?.fingerabdruckDevice)
  );
  readonly lichtbildDevice$ = this.userSettings$.pipe(
    map((userSettings) => userSettings?.lichtbildDevice)
  );

  constructor(private httpClient: HttpClient) {
  }

  fetchUserSettings() {
    this.httpClient.get<UserSettingsDTO>(this.userSettingsUrl).subscribe(this.handleUserSettingsDTO());
  }

  saveUserSettings(userSettingsDTO: UserSettingsDTO) {
    this.httpClient.put<UserSettingsDTO>(this.userSettingsUrl, userSettingsDTO).subscribe(this.handleUserSettingsDTO());
  }

  private handleUserSettingsDTO() {
    return {
      next: (userSettings: UserSettingsDTO) => this.userSettings.next(userSettings),
      error: () => this.userSettings.next(null)
    };
  }
}
